import Link from 'next/link';
import { useRouter } from 'next/router';
import { useSnackbar } from 'notistack';
import type { FC } from 'react';
import { useEffect } from 'react';
import { Button } from '@/DesignSystem/Component';
import { useLoggedIn } from '@/Module/Auth/Hook';
import { messageCreateAction } from '@/Module/Contact/Store/Action/messageCreateAction';
import { FORM_GLOBAL_VALIDATION_ERROR, LINKS } from '@/Module/Core/Constant';
import { getBookMarkLessonByIdAction } from '@/Module/Lesson/Store/Action';
import { setCanReportAction } from '@/Module/Lesson/Store/Slice/LessonSectionSlice';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
const LessonDetailCrashReport: FC = () => {
  const {
    enqueueSnackbar
  } = useSnackbar();
  const router = useRouter();
  const loggedIn = useLoggedIn();
  const person = useAppSelector(state => state.auth.person);
  const lessonSectionSelected = useAppSelector(state => state.lessonSection.selectedLessonSectionId)!;
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!lessonSectionSelected || !loggedIn) return;
    dispatch(getBookMarkLessonByIdAction(lessonSectionSelected));
  }, [lessonSectionSelected, loggedIn]);
  const sendCrashReport = () => {
    const messageText = `ویدئوی درس با شناسه ${lessonSectionSelected} خراب است`;
    dispatch(messageCreateAction({
      fullName: `${person?.name} ${person?.family}`,
      email: person?.email ?? 'no_email@ino.school',
      mobileNumber: person?.phoneNumber,
      messageText,
      subject: 'خرابی ویدئو',
      messageTypeId: 5
    })).unwrap().then(() => {
      enqueueSnackbar({
        variant: 'success',
        message: 'خرابی ویدئو با موفقیت گزارش شد.'
      });
    }).catch(() => {
      enqueueSnackbar({
        variant: 'error',
        message: FORM_GLOBAL_VALIDATION_ERROR
      });
    }).finally(() => {
      dispatch(setCanReportAction(false));
    });
  };
  const onClick = () => {
    if (!loggedIn) {
      enqueueSnackbar({
        variant: 'warning',
        message: 'لطفا لاگین بفرمائید',
        className: 'like--Login',
        action: <Button as={Link} href={`${LINKS.AUTH.LOGIN}?redirectUrl=${encodeURI(router.asPath)}`} variant="text" color="primary" className="mr-4 " size="small" bold>
            ورود
          </Button>
      });
      return;
    }
    sendCrashReport();
  };
  const onCancel = () => {
    dispatch(setCanReportAction(false));
  };
  return <div className="flex flex-row items-center justify-between gap-2 " data-sentry-component="LessonDetailCrashReport" data-sentry-source-file="LessonDetailCrashReport.tsx">
      <span className="text-md whitespace-nowrap font-bold text-orangeFive"> ویدیو مشکل دارد!</span>
      <Button variant="shadow" color="primary" iconButton onClick={onClick} className="!h-9 !w-14 " data-sentry-element="Button" data-sentry-source-file="LessonDetailCrashReport.tsx">
        گزارش
      </Button>
      <Button variant="shadow" color="orange" iconButton onClick={onCancel} className="!h-9 !w-14 text-sm " data-sentry-element="Button" data-sentry-source-file="LessonDetailCrashReport.tsx">
        انصراف
      </Button>
    </div>;
};
export default LessonDetailCrashReport;